import type { CheckoutLuggageService } from '@/scopes/checkout/domain/types'
import { produce } from 'immer'

interface OneClickLuggageServicePayload {
  value: string | null
}

interface SpecialLuggageServicePayload {
  value: boolean
}

interface LuggageServicePayload {
  participantId: string
  value: string | null
  direction: string
}

export function updateOneClickLuggageService(payload: OneClickLuggageServicePayload) {
  return produce((service: CheckoutLuggageService) => {
    service.oneClickSelectedValue = payload.value
    const participantIds = Object.keys(service.participants)
    for (const participantId of participantIds) {
      service.participants[participantId].selectedValueOutbound = null
      service.participants[participantId].selectedValueInbound = null
    }
  })
}

export function updateLuggageService(payload: LuggageServicePayload) {
  return produce((service: CheckoutLuggageService) => {
    service.oneClickSelectedValue = null
    if (payload.direction === 'outbound') {
      service.participants[payload.participantId].selectedValueOutbound = payload.value
    }
    if (payload.direction === 'inbound') {
      service.participants[payload.participantId].selectedValueInbound = payload.value
    }
  })
}

export function updateSpecialLuggageService(payload: SpecialLuggageServicePayload) {
  return produce((service: CheckoutLuggageService) => {
    service.hasSpecialLuggage = payload.value
  })
}
